import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { useRecoilState } from 'recoil';
import { subAtom } from 'core/config/atoms';

import { Building, Bed, Hotel, Edit, TableOfContents, Columns } from "lucide-react";

import ServiceFloor from 'services/serviceFloor';
import moment from 'moment/moment';
import ServiceHostel from 'services/serviceHostel';

const ComponentHostelGrid = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh() {
            loadData();
        }
    }));

    const [sub] = useRecoilState(subAtom);

    const [floors, setFloors] = useState([]);
    const [filterFloor, setFilterFloor] = useState([]);
    const [types, setTypes] = useState([]);

    const [aflor, setAFloor] = useState({});
    const [selUnit, setSelUnit] = useState({});
    const [selSubUnit, setSelSubUnit] = useState({});
    const [booking, setBooking] = useState({});

    const [selFloor, setSelFloor] = useState('all');

    const [openBed, setOpenBed] = useState(false);
    const [openRoom, setOpenRoom] = useState(false);

    const [view, setView] = useState(1);

    const floorService = new ServiceFloor();
    const hostelService = new ServiceHostel();

    const openBedBooking = (subunit) => {
        if (subunit.status !== "none") {
            setSelSubUnit(subunit);
            hostelService.getBookingById({ "bookid": subunit.bookingid }, '').then((res) => {
                setBooking(res.data);
                setOpenBed(true);
            });
        }
    }

    const sortTable = (filter) => {
        setSelFloor(filter);
        if (filter === 'all') {
            setFilterFloor(floors);
        } else {
            let tempList = floors.filter((item) => item.title === filter);
            setFilterFloor(tempList);
        }
    }

    const getColor = (sts) => {
        switch (sts) {
            case 'in':
                return 'bg-green-200';
            case 'out':
                return 'bg-red-200';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const getChipColor = (sts) => {
        switch (sts) {
            case 'inprog':
                return 'bg-yellow-100 text-yellow-600';
            case 'closed':
                return 'bg-green-100 text-green-600';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const getStatus = (sts) => {
        switch (sts) {
            case 'in':
                return "bg-green-600 text-white";
            case 'out':
                return "bg-red-600 text-white";
            case 'none':
            default:
                return "text-blue-600 bg-blue-100";
        }
    }

    const getActive = (subunits) => {
        if (subunits === undefined) return 0;
        return subunits.filter((a) => a.status !== "none").length;
    }

    const getRoomType = (id) => {
        const items = types.filter((type) => type._id === id);
        if (items.length !== 0) {
            return items[0]['name'];
        }
        return "NA";
    }

    const markIn = () => {
        var body = {
            roomFloor: booking.roomFloor,
            roomIndex: booking.roomIndex,
            roomBed: booking.roomBed,
            custId: booking.customerId[0]._id,
            bookId: booking._id,
        };
        hostelService.markIn(body, '').then((res) => {
            setAFloor({});
            setSelUnit({});
            setOpenRoom(false);
            setSelSubUnit({});
            setBooking({});
            setOpenBed(false);
            loadData();
        });
    }

    const markOut = () => {
        var body = {
            roomFloor: booking.roomFloor,
            roomIndex: booking.roomIndex,
            roomBed: booking.roomBed,
            custId: booking.customerId[0]._id,
            bookId: booking._id,
        };
        hostelService.markOut(body, '').then((res) => {
            setAFloor({});
            setSelUnit({});
            setOpenRoom(false);
            setSelSubUnit({});
            setBooking({});
            setOpenBed(false);
            loadData();
        });
    }

    const markClose = () => {
        var body = {
            roomFloor: booking.roomFloor,
            roomIndex: booking.roomIndex,
            roomBed: booking.roomBed,
            custId: booking.customerId[0]._id,
            bookId: booking._id,
        };
        hostelService.checkOutBed(body, '').then((res) => {
            setAFloor({});
            setSelUnit({});
            setOpenRoom(false);
            setSelSubUnit({});
            setBooking({});
            setOpenBed(false);
            loadData();
        });
    }

    const getTax = (finalTotal, tax) => {
        let taxAmount = 0;
        if (tax > 0) {
            taxAmount = finalTotal - finalTotal / (1 + tax / 100);
        }
        return taxAmount.toFixed(2);
    }

    const loadData = () => {
        (async function () {
            var res = await floorService.getAllRoomType({}, '');
            setTypes(res.data);

            var doc = await floorService.getAllFloor({}, '');
            setFloors(doc.data);
            setFilterFloor(doc.data);
            setSelFloor('all');
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {
                openRoom && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>{aflor.title} - {selUnit.title}</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setAFloor({});
                                        setSelUnit({});
                                        setOpenRoom(false);
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='w-full my-4 border border-gray-200 border-dashed p-1 rounded'>
                                    <div className='w-full'>
                                        <div className='flex items-center justify-between'>
                                            <div className='flex items-center'>
                                                <Bed size={22} />
                                                <h1 className='text-xl font-medium uppercase ml-1'>BEDS</h1>
                                            </div>
                                        </div>
                                        <div className='my-2 h-[1px] bg-gray-300'></div>
                                    </div>
                                    <div className='w-full grid grid-cols-6 p-2'>
                                        {
                                            selUnit.subunit === undefined && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            selUnit.subunit !== undefined && selUnit.subunit.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            selUnit.subunit !== undefined && selUnit.subunit.length !== 0 && <div className="rounded col-span-6 cursor-pointer">
                                                <div className='grid grid-cols-7'>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Name</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Price</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Start Date</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>End Date</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Customer</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>Status</p>
                                                    </div>
                                                    <div className='col-span-1'>
                                                        <p className='text-base font-medium font-serif'>-</p>
                                                    </div>
                                                    <div className='col-span-7 bg-gray-200 h-[1px] my-1'></div>
                                                    {
                                                        selUnit.subunit.map((bed, index) => {
                                                            return <div className={`h-[40px] col-span-7 grid grid-cols-7 p-1 rounded mb-1 ${getColor(bed.status)}`} key={index}>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <Bed size={20} className='cursor-pointer' />
                                                                    <p className='text-base font-serif ml-2'>{bed.title}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>₹ {bed.price.toFixed(2)}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>{moment(bed.startTime).format("DD, MMM yy")}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-serif'>{moment(bed.endTime).format("DD, MMM yy")}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className='text-base font-medium font-serif'>-</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    <p className={`text-xs font-medium font-serif text-blue-600 bg-blue-100 px-4 py-1 rounded-full uppercase ${getStatus(bed.status)}`}>{bed.status}</p>
                                                                </div>
                                                                <div className='col-span-1 flex items-center'>
                                                                    {
                                                                        bed.status !== "none" ? <div className='cursor-pointer text-red-600' onClick={() => { openBedBooking(bed); }}>
                                                                            <Edit size={18} />
                                                                        </div> : <div className='text-gray-600'>
                                                                            -
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div >
                </div>
            }
            {
                openBed && <div className='overflow-y-auto overflow-x-hidden z-[200] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 py-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>Booking #{booking.bookid}</h1>
                                    <span onClick={() => {
                                        setSelSubUnit({});
                                        setBooking({});
                                        setOpenBed(false);
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-2' />
                                <div className='flex'>
                                    <p className='font-sans font-medium'>Order Type:
                                        <span className={`ml-4 px-3 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800`}>
                                            Hostel Booking
                                        </span>
                                    </p>
                                    <p className='ml-8 font-sans font-medium'>Status:
                                        <span className={`ml-4 px-4 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${getChipColor(booking.status)}`}>
                                            {booking.status}
                                        </span>
                                    </p>
                                </div>
                                <div className='mt-1 text-sm'>
                                    Created At: <b>{moment(booking.createdAt).format('DD MMM, yyyy hh:mm:ss A')}</b>
                                </div>
                                <hr className='my-2' />
                                {
                                    booking.status !== "closed" && <div className='flex mt-2 space-x-2'>
                                        {
                                            selSubUnit.status === "out" && <div className="py-2 rounded-md shadow-lg text-center bg-green-600 text-white font-semibold cursor-pointer flex-grow" onClick={() => { markIn(); }}>
                                                MARK IN
                                            </div>
                                        }
                                        {
                                            selSubUnit.status === "in" && <div className="py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow" onClick={() => { markOut(); }}>
                                                MARK OUT
                                            </div>
                                        }
                                        <div className="py-2 rounded-md shadow-lg text-center bg-black text-white font-semibold cursor-pointer flex-grow" onClick={() => { markClose(); }}>
                                            CLOSE BOOKING
                                        </div>
                                    </div>
                                }
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Booking Summery
                                    </span>
                                </div>
                                <div className='mt-2 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                </div>
                                <hr className='my-2' />
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Booking Start</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{moment(booking.checkIn).format('DD MMM, yyyy')}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Booking End</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{moment(booking.checkOut).format('DD MMM, yyyy')}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Floor</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.title}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Room</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.units[booking.roomIndex].title}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Bed</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.units[booking.roomIndex].subunit[booking.roomBed].title}</p>
                                </div>
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Payment Summery
                                    </span>
                                </div>
                                <div className="w-full mt-2 space-y-1">
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">Subtotal</span>
                                        <span className="font-medium text-sm">₹ {booking.total.toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">Extra Charges Charges</span>
                                        <span className="font-medium text-sm">₹ {booking.extraCharge.toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">@ Discount (₹)</span>
                                        <span className="font-medium text-sm">₹ {booking.discount.toFixed(2)}</span>
                                    </div>
                                    {
                                        sub.features.isTax && <div className="flex justify-between">
                                            <span className="font-medium text-sm">Tax (₹)</span>
                                            <span className="font-medium text-sm">₹ {getTax(booking.finaltotal, booking.tax)}</span>
                                        </div>
                                    }
                                    <div className="border-t-2 mt-2 py-2 flex items-center justify-between">
                                        <span className="font-medium text-lg">Total</span>
                                        <span className="font-medium text-lg">₹ {booking.finaltotal.toFixed(2)}</span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Customer Summery
                                    </span>
                                </div>
                                <div className='mt-2 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].name}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Phone</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].phone}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Email</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].email}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Collage Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].extra.clgName === "" ? "NA" : booking.customerId[0].extra.clgName}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Document Number</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].extra.docNum === "" ? "NA" : booking.customerId[0].extra.docNum}</p>
                                </div>
                                <div className=''>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Document</p>
                                    <div className='w-full border overflow-hidden rounded relative'>
                                        <img src={booking.customerId[0].extra.docFile.fileurl} alt='document' className='w-full object-fill' />
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div>
                </div>
            }
            <div className='w-full min-h-[86vh] px-2 py-2 bg-white rounded-md grid grid-cols-12 gap-1'>
                <div className='col-span-2 border-r p-1'>
                    <ScrollArea className='h-[calc(86vh-16px)]'>
                        <ul>
                            <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === 'all' ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} onClick={() => {
                                sortTable('all');
                            }}>
                                All Floors
                            </li>
                            {
                                floors.length !== 0 && floors.map((cunit) => {
                                    return <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === cunit.title ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} key={cunit._id}>
                                        <div className='flex items-center justify-between'>
                                            <span className='flex-grow' onClick={() => { sortTable(cunit.title); }}>{cunit.title}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                    </ScrollArea>
                </div>
                <div className="col-span-10 p-1">
                    <ScrollArea className="h-[calc(86vh-16px)] overflow-hidden">
                        <div className='flex space-x-2'>
                            <div className={`w-9 h-9 flex items-center justify-center cursor-pointer rounded text-white ${view === 0 ? "bg-red-600" : "bg-gray-400"}`} onClick={() => setView(0)}>
                                <Columns size={20} />
                            </div>
                            <div className={`w-9 h-9 flex items-center justify-center cursor-pointer rounded text-white ${view === 1 ? "bg-red-600" : "bg-gray-400"}`} onClick={() => setView(1)}>
                                <TableOfContents size={20} />
                            </div>
                        </div>
                        {
                            filterFloor.length !== 0 && filterFloor.map((cuint) => {
                                return <div className='w-full my-3 border border-gray-200 border-dashed p-1 rounded'>
                                    <div className='w-full'>
                                        <div className='flex items-center justify-between'>
                                            <div className='flex items-center'>
                                                <Building size={22} />
                                                <h1 className='text-xl font-medium uppercase ml-1'>{cuint.title}</h1>
                                            </div>
                                        </div>
                                        <div className='my-2 h-[1px] bg-gray-300'></div>
                                    </div>
                                    <div className='w-full grid grid-cols-4 gap-2'>
                                        {
                                            cuint.units.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                            </div>
                                        }
                                        {
                                            view === 0 && cuint.units.length !== 0 && cuint.units.map((unit, index) => {
                                                if (unit.type === 'Room') {
                                                    return < div className={`h-[130px] p-2 rounded shadow col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${getColor(unit.status)}`} key={index} onClick={() => {
                                                        setAFloor(cuint);
                                                        setSelUnit(unit);
                                                        setOpenRoom(true);
                                                    }}>
                                                        <div className='flex justify-between items-center px-1'>
                                                            <div>
                                                                <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                                <p className='text-xs font-medium font-serif text-prime'>{getRoomType(unit.roomTypeId)}</p>
                                                                <p className='text-base font-medium font-serif mt-1'>₹ {unit.pending.toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                        <div className='bg-gray-200 h-[1px] my-2'></div>
                                                        <div className='flex items-center justify-between'>
                                                            <div className='flex text-sm items-center text-prime'>{getActive(unit.subunit)} of {unit.subunit !== undefined ? unit.subunit.length : 0} Beds Active</div>
                                                            <Bed size={18} className='cursor-pointer' />
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                        {
                                            view === 1 && cuint.units.length !== 0 && cuint.units.map((unit, index) => {
                                                if (unit.type === 'Room') {
                                                    return <div className='col-span-6 my-1 border border-gray-200 border-dashed p-1 rounded'>
                                                        <div className='w-full'>
                                                            <div className='flex items-center justify-between'>
                                                                <div className='flex items-center'>
                                                                    <Hotel size={22} />
                                                                    <h1 className='text-xl font-medium uppercase ml-1'>{unit.title}</h1>
                                                                </div>
                                                            </div>
                                                            <div className='my-2 h-[1px] bg-gray-300'></div>
                                                        </div>
                                                        <div className='w-full grid grid-cols-6 p-2'>
                                                            {
                                                                unit.subunit === undefined && < div className='h-[60px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                                    <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                                                </div>
                                                            }
                                                            {
                                                                unit.subunit !== undefined && unit.subunit.length === 0 && < div className='h-[60px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                                                    <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                                                </div>
                                                            }
                                                            {
                                                                unit.subunit !== undefined && unit.subunit.length !== 0 && <div className="rounded col-span-6 cursor-pointer">
                                                                    <div className='grid grid-cols-7'>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>Name</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>Price</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>Start Date</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>End Date</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>Customer</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>Status</p>
                                                                        </div>
                                                                        <div className='col-span-1'>
                                                                            <p className='text-base font-medium font-serif'>-</p>
                                                                        </div>
                                                                        <div className='col-span-7 bg-gray-200 h-[1px] my-1'></div>
                                                                        {
                                                                            unit.subunit.map((bed, index) => {
                                                                                return <div className={`h-[40px] col-span-7 grid grid-cols-7 p-1 rounded mb-1 ${getColor(bed.status)}`} key={index} onClick={() => { openBedBooking(bed); }}>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <Bed size={20} className='cursor-pointer' />
                                                                                        <p className='text-base font-serif ml-2'>{bed.title}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <p className='text-base font-serif'>₹ {bed.price.toFixed(2)}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <p className='text-base font-serif'>{moment(bed.startTime).format("DD, MMM yy")}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <p className='text-base font-serif'>{moment(bed.endTime).format("DD, MMM yy")}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <p className='text-base font-medium font-serif'>{bed.status === "none" ? "-" : bed.custName}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <p className={`text-xs font-medium font-serif px-4 py-1 rounded-full uppercase ${getStatus(bed.status)}`}>{bed.status}</p>
                                                                                    </div>
                                                                                    <div className='col-span-1 flex items-center'>
                                                                                        <div className='cursor-pointer text-red-600' onClick={() => { }}>
                                                                                            <Edit size={16} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            })
                        }
                    </ScrollArea>
                </div>
            </div>
        </>
    )
});

export default ComponentHostelGrid;
